<!-- Séparer l’état de lecture des métadonnées de celui de chaque téléchargement. -->
<section aria-label="Photos de l’intervention">
  <h3>Photos</h3>
  @if (sessionFermee()) {
    <p role="status">La session a changé. Rouvrez l’intervention pour consulter ses photos.</p>
  } @else if (chargement()) {
    <p role="status">Chargement des photos…</p>
  } @else {
    @if (erreur()) {
      <p class="erreur" role="alert">{{ erreur() }}</p>
    } @else if (!apercus().length) {
      <p>Aucune photo enregistrée.</p>
    }
    <ul>
      @for (apercu of apercus(); track apercu.photo.id) {
        <li>
          <strong>{{ apercu.photo.nom }}</strong>
          @if (apercu.erreur) {
            <p class="erreur" role="alert">{{ apercu.erreur }}</p>
          } @else if (apercu.url; as url) {
            <!-- URL de blob obtenue via HttpClient authentifié, partagée par l’aperçu et les liens. -->
            <a
              [href]="url"
              target="_blank"
              rel="noopener"
              [attr.aria-label]="'Voir la photo ' + apercu.photo.nom + ' (nouvel onglet)'"
            >
              <img
                [src]="url"
                [alt]="apercu.photo.nom"
                width="240"
                height="160"
                (error)="imageIllisible(apercu.photo.id)"
              />
            </a>
            <a
              class="telecharger"
              [href]="url"
              [download]="apercu.photo.nom"
              [attr.aria-label]="'Télécharger la photo ' + apercu.photo.nom"
              >Télécharger</a
            >
          } @else {
            <p role="status">Chargement de l’image…</p>
          }
        </li>
      }
    </ul>
    <!-- Une erreur de fichier laisse les autres aperçus visibles et permet une nouvelle tentative. -->
    @if (peutReessayer()) {
      <button type="button" (click)="reessayer()">Réessayer le chargement des photos</button>
    }
  }
</section>
